import React from 'react';
import IsTemporaryUserForm from '@/components/Landing/Forms/IsTemporaryUserForm/IsTemporaryUserForm';
import LandingWrapper from '@components/Landing/LandingWrapper/LandingWrapper';

const IsTemporaryUser = () => {
  return <LandingWrapper Form={IsTemporaryUserForm} />;
};

export default IsTemporaryUser;
